module.exports = __webpack_public_path__ + "img/marnLogo.c5901f30.png";